import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'lib/widgets/Button/Button';

class CardItemsSavingTime extends PureComponent {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    rightArrowIcon: PropTypes.string,
    instantShopExists: PropTypes.bool.isRequired,
    oReservedExists: PropTypes.string,
  };

  render() {
    const {
      icon,
      header,
      content,
      buttonText,
      buttonLink,
      rightArrowIcon,
      instantShopExists,
      oReservedExists,
    } = this.props;

    // conditionally render the card if the header is 'Instant shop' and instantShopExists is false
    if (header === 'Instant shop' && !instantShopExists) {
      return null;
    }

    // conditionally render the card if the header is 'Reserved' and oReservedExists is false
    if (header === 'Reserved' && !oReservedExists) {
      return null;
    }

    return (

      <div className="card-items-saving-time">
        <div className="card-items-saving-time__header">
          <img className="card-items-saving-time__icon" src={icon} alt={`${header} Icon`} />
          <h2 className="card-items-saving-time__header-text">{header}</h2>
        </div>
        <div className="card-items-saving-time__content">
          {content}
          <div className="card-items-saving-time__footer">
            {buttonText && (
              <Button
                secondary
                className="card-items-saving-time__button"
                to={buttonLink}
              >
                {buttonText}
                {rightArrowIcon && (
                  <img src={rightArrowIcon} alt="Right Arrow Icon" className="right-arrow-icon" />
                )}
              </Button>
            )}
          </div>
        </div>

      </div>

    );
  }
}

export default CardItemsSavingTime;
